import { ResponseError } from '../../errors';
import { IGetUriRequest, TGetUriResponse, fetchGetUri } from '../../repositories/seo-urls/v1/get-uri';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchSeoUrl(
  { httpApi, logger }: IApplicationContext,
  parameters: IGetUriRequest,
): Promise<string | undefined> {
  try {
    const responseData: TGetUriResponse = await fetchGetUri({ httpApi, parameters });

    if (responseData.statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchSeoUrl',
        message: responseData.response.message || '',
        details: {
          errors: JSON.stringify(responseData.response.errors),
        },
      });
    }

    return responseData.response.uri ?? undefined;
  } catch (error) {
    logger.warning(error);

    return;
  }
}
